module.exports = __webpack_public_path__ + "static/img/ls.c0799ebf.svg";